import React from "react";
import { Menu, MenuItem, Typography } from "@mui/material";

export default function ShareMenu({
  anchorEl,
  open,
  onClose,
  shareUrl,
  title,
  pay,
  location,
  deadline,
  projectType,
  unionStatus,
  onCopySuccess,
}) {
  const handleCopy = async () => {
    await navigator.clipboard.writeText(shareUrl);
    onCopySuccess?.();
    onClose();
  };

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString();
  };

  const shareMessage = [
    "🎬 CASTING CALL",
    "",
    title && `🎭 Project: ${title}`,
    projectType && `🎥 Type: ${projectType}`,
    location && `📍 Location: ${location}`,
    unionStatus && `🤝 Union: ${unionStatus}`,
    pay && `💰 Compensation: ${pay}`,
    deadline && `📅 Submission Deadline: ${formatDate(deadline)}`,
    "",
    "View the complete casting call and apply here:",
    shareUrl,
    "",
    "Powered by DirectSubmit",
  ]
    .filter(Boolean)
    .join("\n");

  const encodedMessage = encodeURIComponent(shareMessage);
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(
    `Casting Call${title ? ` - ${title}` : ""}`
  );

  const urls = {
    WHATSAPP: `https://api.whatsapp.com/send?text=${encodedMessage}`,

    EMAIL: `mailto:?subject=${encodedTitle}&body=${encodedMessage}`,

    TWITTER: `https://twitter.com/intent/tweet?text=${encodedMessage}`,

    LINKEDIN: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}`,

    FACEBOOK: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
  };

  const handleShare = (platform) => {
    window.open(urls[platform], "_blank", "noopener,noreferrer");
    onClose();
  };

  const menuItemStyle = {
    justifyContent: "center",
    backgroundColor: "#8fb2ff",
    color: "#fff",
    borderRadius: 1,
    fontSize: "0.75rem",
    fontWeight: 600,
    mb: 0.75,
    mx: 1,
    "&:hover": {
      backgroundColor: "#739cff",
    },
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      disableScrollLock
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1.5,
          minWidth: 200,
          boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.15)",
        },
      }}
      MenuListProps={{
        sx: { p: 0 },
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 600,
          mb: 1,
          px: 1,
        }}
      >
        Share via
      </Typography>

      <MenuItem onClick={handleCopy} sx={menuItemStyle}>
        COPY LINK
      </MenuItem>

      {["WHATSAPP", "EMAIL", "TWITTER", "LINKEDIN", "FACEBOOK"].map(
        (platform) => (
          <MenuItem
            key={platform}
            onClick={() => handleShare(platform)}
            sx={menuItemStyle}
          >
            {platform}
          </MenuItem>
        )
      )}
    </Menu>
  );
}